import { render, staticRenderFns } from "./updateTrainingProgress.vue?vue&type=template&id=be596846&scoped=true"
import script from "./updateTrainingProgress.vue?vue&type=script&lang=js"
export * from "./updateTrainingProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be596846",
  null
  
)

export default component.exports